import moment from "moment";
import { findModuleInMenu } from "../../helpers/Utils";

export default (context) => {
  const M = "admActivity.";
  const admActivityParts = findModuleInMenu(context.props.menuItems, "id", "admActivityParts");

  const mapSelectList = (list) => {
    if (!list) return list;
    return list.map((e) => ({
      ID: e.value,
      name: e.label,
      selected: true
    }));
  };

  return {
    config: {
      pageSize: 40,
      resource: "admActivity",
      enableContexMenu: true,
      remapRow: (form) => form
    },

    actions: {
      create: { reloadGrid: true },
      edit: { reloadGrid: true },
      delete: true,
      print: false,
      export: true,
      search: true
    },

    extras: {
      itemsInRowsTable: admActivityParts ? [
        {
          id: 1,
          icon: "simple-icon-clock",
          name: `${M}classSchedules`,
          onClick: (rowData, ctx) => {
            const index = ctx.view.extras.itemsInRowsTable.findIndex((f) => f.id === 1);
            if (index > -1) {
              const L = ctx.state.L || {};
              const title = L[`${M}classSchedules`] || "Horarios de clases";
              ctx.view.extras.itemsInRowsTable[index].form.name = `${title}: ${rowData.name}`;
            }
          },
          form: {
            name: `${M}classSchedules`,
            remapGET: () => ({
              parentId: context.state.idItemPreSelected
            }),
            fields: [
              {
                name: "parentId",
                value: 0,
                type: "hidden"
              }
            ],
            detailGrid: () => ({
              module: "admActivityParts",
              parentIdField: "parentId",
              filterBy: (c) => ({
                parentId: c.state.parentId,
                sortBy: "name",
                desc: false
              })
            }),
            onSuccess: () => {},
            onError: () => {}
          }
        }
      ] : []
    },

    filter: {
      fields: [
        {
          name: "type",
          value: "act",
          type: "select",
          label: "main.type",
          opts: {
            style: "float-label",
            isClearable: false,
            items: [
              { value: "act", label: `${M}typeExtracurricular` },
              { value: "ayr", label: `${M}typeAcademicYear` },
              { value: "cal", label: `${M}typeCalendar` }
            ]
          }
        },
        {
          name: "toDateType",
          value: 2,
          type: "select",
          label: "main.status",
          opts: {
            style: "float-label",
            items: [
              { value: 0, label: `${M}registrationsValidOn` },
              { value: 1, label: `${M}startedOn` },
              { value: 2, label: `${M}publishedOn` }
            ]
          }
        },
        {
          name: "toDate",
          value: moment().format("YYYY-MM-DD"),
          type: "date",
          label: "main.date",
          opts: {
            style: "float-label"
          }
        }
      ],
      buttons: [
        {
          label: "main.applyFilter",
          onClick: (ctx) => { ctx.btnAction("filter"); }
        }
      ]
    },

    form: {
      cloneable: true,
      remapOne: (r) => {
        if (r.status >= 0) {
          if (r.data.categoryId) {
            r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName };
          }
          if (r.data.owner) {
            r.data.owner = { value: r.data.owner, label: r.data.ownerName };
          }
        }
        return r;
      },
      setValuesBeforePost: (v) => {
        if (typeof v.categoryId === "object") v.categoryId = v.categoryId?.value;
        if (typeof v.owner === "object") v.owner = v.owner?.value;
        if (v.superSections) v.superSections = mapSelectList(v.superSections);
        if (v.sections) v.sections = mapSelectList(v.sections);
        if (v.groups) v.groups = mapSelectList(v.groups);
        if (!v.type) v.type = context.state?.formFilter?.type || "act";
        delete v.selectedField;
        return v;
      },
      fields: [
        {
          col: 12,
          name: "ID",
          value: null,
          type: "hide"
        },
        {
          col: 12,
          name: "type",
          value: "act",
          type: "hidden"
        },
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: "main.name",
          rules: "required|max:50",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 12,
          name: "img",
          value: "",
          type: "dropzone",
          label: "main.coverImage",
          isDoc: false,
          rules: "ext:jpeg,jpg,png",
          opts: {
            path: () => "/admActivity/file",
            accept: ".jpeg,.jpg,.png",
            output: true
          }
        },
        {
          col: 6,
          name: "locationTxt",
          value: "",
          type: "text",
          label: "main.location",
          rules: "max:50",
          opts: {
            style: "float-label"
          }
        },
        {
          col: 6,
          name: "categoryId",
          value: "",
          type: "select",
          label: "main.category",
          rules: "required",
          opts: {
            style: "float-label",
            path: "/admCategory/get",
            setOutput: (v) => v
          }
        },
        {
          col: 12,
          name: "desc",
          value: "",
          type: "textarea",
          label: "main.desc",
          opts: {
            style: "float-label",
            rows: 4
          }
        },
        {
          col: 6,
          name: "startDate",
          value: moment().format("YYYY-MM-DD"),
          type: "datetime",
          label: `${M}periodStart`,
          rules: "required",
          opts: {
            style: "float-label",
            timeIntervals: 15
          }
        },
        {
          col: 6,
          name: "endDate",
          value: "",
          type: "datetime",
          label: `${M}periodEnd`,
          opts: {
            style: "float-label",
            timeIntervals: 15
          }
        },
        {
          col: 6,
          name: "hasRegistration",
          value: false,
          type: "switch",
          label: `${M}onlineRegistration`
        },
        {
          col: 6,
          name: "paid",
          value: false,
          type: "switch",
          label: `${M}onlinePayment`,
          renderIf: (ctx) => ctx.state.hasRegistration
        },
        {
          col: 4,
          name: "registerFrom",
          value: moment({ hour: 8 }).format("YYYY-MM-DD"),
          type: "datetime",
          label: `${M}registerFrom`,
          opts: {
            style: "float-label",
            timeIntervals: 15
          },
          renderIf: (ctx) => ctx.state.hasRegistration
        },
        {
          col: 4,
          name: "registerTo",
          value: "",
          type: "datetime",
          label: `${M}registerTo`,
          opts: {
            style: "float-label",
            timeIntervals: 15
          },
          renderIf: (ctx) => ctx.state.hasRegistration
        },
        {
          col: 4,
          name: "maxRegistrationInParts",
          value: 1,
          type: "number",
          label: `${M}maxRegistrationsInParts`,
          rules: "required|numeric",
          opts: {
            style: "float-label"
          },
          renderIf: (ctx) => ctx.state.hasRegistration
        },
        {
          col: 12,
          name: "published",
          value: false,
          type: "switch",
          label: `${M}publishedVisible`
        },
        {
          col: 6,
          name: "publishFrom",
          value: "",
          type: "datetime",
          label: `${M}publishFrom`,
          opts: {
            style: "float-label",
            timeIntervals: 15
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "publishTo",
          value: "",
          type: "datetime",
          label: `${M}publishTo`,
          opts: {
            style: "float-label",
            timeIntervals: 15
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "hasDate",
          value: false,
          type: "switch",
          label: `${M}showInCalendar`
        },
        {
          col: 6,
          name: "owner",
          value: "",
          type: "select",
          label: "main.responsible",
          opts: {
            style: "float-label",
            path: "/admStaff/get?pick=true",
            setOutput: (v) => v
          }
        },
        {
          col: 6,
          name: "superSections",
          value: "",
          type: "select",
          label: `${M}visibleForGrades`,
          opts: {
            style: "float-label",
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: (v) => v
          },
          renderIf: (ctx) => ctx.state.published
        },
        {
          col: 6,
          name: "sections",
          value: "",
          type: "select",
          label: `${M}visibleForClasses`,
          parent: "superSections",
          opts: {
            style: "float-label",
            path: () => {
              const ss = context.state.form?.superSections;
              const parentId = ss && ss.length > 0 ? ss[0].value : null;
              return "/admSection/get?pick=true&parentId=" + parentId;
            },
            isMulti: true,
            setOutput: (v) => v
          },
          renderIf: (ctx) => (ctx.state.superSections && ctx.state.superSections.length === 1) || (ctx.state.sections && ctx.state.sections.length >= 1)
        },
        {
          col: 6,
          name: "groups",
          value: "",
          type: "select",
          label: `${M}enabledForGroups`,
          opts: {
            style: "float-label",
            path: "/admGroup/get?staff=2",
            isMulti: true,
            setOutput: (v) => v
          },
          renderIf: (ctx) => ctx.state.hasRegistration
        },
        {
          col: 6,
          name: "notify",
          value: false,
          type: "switch",
          label: `${M}notifyOnRegistration`
        },
        {
          col: 6,
          name: "remind",
          value: false,
          type: "switch",
          label: `${M}sendReminder`
        },
        {
          col: 12,
          name: "btnHorarios",
          value: null,
          type: "button",
          label: `${M}classSchedules`,
          opts: {
            style: "float-label"
          },
          renderIf: () => !!context.state.idItemSelected && !!admActivityParts,
          onClick: (ctx) => {
            ctx.toogleSubGrid(0);
          }
        }
      ],
      subGrids: admActivityParts ? [
        {
          name: (ctx) => {
            const L = context.state.L || {};
            const title = L[`${M}classSchedules`] || "Horarios de clases";
            return `${title}: ${ctx.state.name || ""}`;
          },
          module: "admActivityParts",
          parentId: () => context.state.idItemSelected,
          parentIdField: "ID",
          filterBy: () => ({
            parentId: context.state.idItemSelected,
            sortBy: "name",
            desc: false
          })
        }
      ] : [],
      detailGrid: admActivityParts ? () => ({
        module: "admActivityParts",
        parentIdField: "ID",
        renderIf: () => context.state.form && context.state.form.ID
      }) : null
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID",
        maxWidth: 60
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: `${M}periodStart`,
        accessor: "startDate",
        isDate: true
      },
      {
        Header: `${M}periodEnd`,
        accessor: "endDate",
        isDate: true
      },
      {
        Header: "main.category",
        accessor: "categ"
      },
      {
        Header: "main.responsible",
        accessor: "owner"
      },
      {
        Header: `${M}parts`,
        accessor: "parts",
        maxWidth: 70
      }
    ]
  };
};
